:host {
  display: block;
  font-family: sans-serif;
  margin: 2px;
}

.file-thumb {
  display: flex;
  align-items: center;
  color: white;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  min-width: 200px;
}

.file-thumb-default {
  background: #000000;
}

.file-thumb-step-750 {
  background: var(--ion-color-step-750);
}

.file-thumb-transparent {
  background: transparent;
}

.file-image {
  margin-right: 10px;
  flex-shrink: 0;
}

.file-image img {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
  background: #fff;
}

.file-image img.file-icon {
  object-fit: contain;
  padding: 8px;
  background: #f5f5f5;
}

.file-info {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.file-name {
  font-weight: bold;
  font-size: 15px;
  display: block;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.file-details {
  display: block;
  font-size: 10px;
  color: Silver;
  line-height: 1;
  margin-bottom: 2px;
}

.file-date {
  display: block;
}

ion-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 18px;
  color: white;
  opacity: 0.7;
  cursor: pointer;
}

ion-icon:hover {
  opacity: 1;
}

/* Hover effect */
.file-thumb:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
  transition: all 0.2s ease;
}

/* Clickable state */
.file-thumb.clickable {
  cursor: pointer;
}

.file-thumb.clickable:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
} 